import React from 'react'

const DashboardNotifications = () => {
	return <div>DashboardNotifications</div>
}

export default DashboardNotifications
